<template>
  <header>
    年齢認証
    <div class="h-left">
      <a
        href="#"
        @click="redirectBack()"
        ><img src="~@/assets/images/icon02.svg"
      /></a>
    </div>
  </header>
  <div id="wrap" style="padding-bottom: 100px;">
    <img src="~@/assets/images/age01.jpg" />
    <img src="~@/assets/images/age02.png" />
    <div class="age01">
      <p>現在登録されている年齢</p>
      <p>{{userDetail.age}}歳</p>
    </div>
    <img src="~@/assets/images/age03.png" />
    <div class="cp_iptxt">
      <div class="select">
        <select v-model="year" @change="checkTime">
          <option value="">-</option>
          <option
            v-for="item in parseInt(new Date().getFullYear()) - 18 - 1900 + 1"
            :key="item + 1899"
            :value="item + 1899"
          >
            {{ item + 1899 }}
          </option>
        </select>
        年
        <select v-model="month" @change="checkTime">
          <option :value="null" disabled selected>-</option>
          <option
            v-for="item in 12"
            :value="item"
            :key="item"
            :disabled="checkBirthdayMonth(item, year) ? false : true"
          >
            {{ item }}
          </option>
        </select>
        月
        <select v-model="day" @change="checkTime">
          <option :value="null" disabled selected>-</option>
          <option
            v-for="item in daysInMonth"
            :value="item"
            :key="item"
            :disabled="checkBirthdayDate(item, month, year) ? false : true"
          >
            {{ item }}
          </option>
        </select>
        日
        <i class="fas fa-birthday-cake fa-lg fa-fw ll2" aria-hidden="true"></i>
      </div>
    </div>

    <div class="btn1"><a @click="openImageModal">年齢確認をはじめる</a></div>
  </div>
  <basicDialog :active="isShowChooseTypeImage">
    <div class="flex-row">
      <button class="btn-start" @click="openCamera">カメラから</button>
      <button class="btn-end" @click="openFile">ギャラリーから</button>
      <button class="btn-close" @click="isShowChooseTypeImage = false">
        キャンセル
      </button>
      <input type="file" name="fileImage" hidden />
    </div>
  </basicDialog>
  <successDialog :active="isVerySuccess" @close="closeAlert">
    <template v-slot:title>
      <p>
        年齢承認
      </p>
    </template>
    <template v-slot:message>
      <p>
        年齢認証年齢認証の申込みを受け付けました。審査は通常24時間以内に完了します。
      </p>
    </template>
  </successDialog>
  <input type="file" accept="image/*" id="camera" capture="camera" hidden />
  <input type="file" accept="image/*" id="image" hidden />
  <div class="loading-screen" v-if="isLoading">
    <div class="loader"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CONSTANTS from "@/constants";
import basicDialog from "./components/basicDialog";
import successDialog from "@/views/components/successDialog";
import mixin from "@/mixin";
export default {
  props: {
    isShow: Boolean
  },
  components: {
    basicDialog,
    successDialog,
  },
  mixins: [mixin],
  emits: ['close'],
  data: () => ({
    isShowChooseTypeImage: false,
    file: null,
    isVerySuccess: false,
    year: null,
    month: null,
    day: null,
    daysInMonth: new Date(parseInt(new Date().getFullYear()) - 18, 1, 0).getDate(),
    isLoading: false
  }),
  mounted() {
    this.setFooter(false);
    let birthday = this.userDetail.birthday.split('-');
    this.year = birthday[0];
    this.month = Number(birthday[1]);
    this.day = Number(birthday[2]);
  },
  computed: {
    ...mapGetters(["defaultToken", "userDetail"]),
  },
  methods: {
    ...mapActions({
      setFooter: "layout/setFooter",
      userProfile: "user/userProfile",
    }),
    redirectBack() {
      if (this.isShow) {
        this.$emit('close')
      } else {
        this.$router.push({name: 'profile'})
        this.setFooter(true)
      }
    },
    async veryAge() {
      let formData = new FormData();
      formData.append("token", this.defaultToken);
      formData.append("type", CONSTANTS.TYPE_VERY_AGE);
      
      this.isLoading = true
      await this.downscaleImage(this.file).then(async file => {
        formData.append("file", file);
         await this.$store
        .dispatch("profile/veryUpload", formData)
        .then(async (data) => {
          await this.userProfile({
            token: this.defaultToken,
          });
          this.isLoading = false
          this.isVerySuccess = true;
        })
        .catch((err) => {
          this.isLoading = false
          console.log(err);
        });
      })
    },
    openImageModal() {
      this.isShowChooseTypeImage = true;
    },
    openCamera() {
      this.isShowChooseTypeImage = false;
      let camera = document.getElementById("camera");
      camera.click();
      camera.addEventListener("change", (e) => {
        this.file = camera.files[0];
        this.veryAge();
      });
    },
    openFile() {
      this.isShowChooseTypeImage = false;
      let camera = document.getElementById("image");
      camera.click();
      camera.addEventListener("change", (e) => {
        this.file = camera.files[0];
        this.veryAge();
      });
    },
    checkTime() {
        this.daysInMonth = new Date(this.year, this.month, 0).getDate()
      if (parseInt(new Date().getFullYear()) - 18 > parseInt(this.year)) {
        return true;
      }
      if (parseInt(new Date().getFullYear()) - 18 === parseInt(this.year)) {
        if (parseInt(new Date().getMonth()) + 1 >= parseInt(this.month)) {
          if (parseInt(new Date().getMonth()) + 1 === parseInt(this.month)) {
            if (parseInt(new Date().getDate()) > this.day) {
              return true;
            } else {
              this.day = 1;
            }
          }
        } else {
          this.month = 1;
        }
        // if (parseInt((new Date).getMonth()) < mounth) {
        //     return false
        // }
      }
    },
    closeAlert() {
        this.isVerySuccess = false
        if (this.isShow) {
          this.$emit('close', true)
        } else {
          this.$router.go(-1)
          this.setFooter(true)
        }
    }
  },
};
</script>

<style scoped>
.flex-row {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.flex-row button {
  outline: none;
  border: none;
  color: #4a87fb;
  width: 100%;
  background: #fff;
  padding: 10px;
}

.flex-row button.btn-start {
  border-bottom: 1px solid rgb(160, 160, 160);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.flex-row button.btn-end {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.flex-row button.btn-close {
  margin-top: 15px;
  border-radius: 5px;
}
.loading-screen {
  background: #00000067;
}
.loader {
  border: 2px solid #fff;
  border-right-color: transparent;
}
</style>
